import React from "react";
import { Link } from "react-router-dom";
import { Calendar, User, ArrowRight, Clock } from "lucide-react";
import "./Blog.css";

const Blog = () => {
  const formatDate = (iso) => {
    try {
      return new Date(iso).toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    } catch {
      return iso;
    }
  };

  // All articles data
  const articles = [
    {
      id: 4,
      title: "Party Anywhere: ChipServer Pro’s Offline Venue Toolkit",
      excerpt:
        "Launch karaoke, collaborative playlists, and rotating slideshows without touching the internet. ChipServer Pro blankets a 200-foot party zone with its own secure network so every guest is in sync.",
      author: "ChipServer Team",
      date: "2025-11-22",
      readTime: "7 min read",
      category: "Events & Culture",
      image: "/Anywhere.png"
    },
    {
      id: 1,
      title: "Global Internet Connectivity 2025: Bridging the Digital Divide in an Interconnected World",
      excerpt: "Explore the current state of global internet connectivity as 5.56 billion people come online, while 2.63 billion remain disconnected.",
      author: "ChipServer Team",
      date: "2025-07-10",
      readTime: "8 min read",
      category: "Global Technology",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=400&fit=crop"
    },
    {
      id: 2,
      title: "🎒 Empowering Education Anywhere with ChipServer",
      excerpt: "Discover how ChipServer's portable, cloud-free Wi-Fi file-sharing device is revolutionizing education in remote classrooms, disaster relief scenarios, and Wi-Fi-challenged institutions.",
      author: "ChipServer Team",
      date: "2025-07-10",
      readTime: "6 min read",
      category: "Education Technology",
      image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&h=400&fit=crop"
    },
    {
      id: 3,
      title: "The offline classroom: how teachers share lessons without internet in 5 minutes",
      excerpt: "A practical, repeatable 5‑minute setup for teachers to deliver lessons offline using ChipServer—including prep checklist, classroom flow, and tips.",
      author: "ChipServer Team",
      date: "2025-11-09",
      readTime: "5 min read",
      category: "Education Technology",
      image: "/Class.png"
    }
  ];

  // Make the party article the featured one (fallback to first if missing)
  const featuredArticle = articles.find(a => a.id === 4) || articles[0];

  return (
    <div className="blog-page">
      {/* Hero Section */}
      <section className="blog-hero">
        <div className="container">
          <h1 className="blog-title">ChipServer Insights</h1>
          <p className="blog-subtitle">
            Stay updated with the latest trends, insights, and innovations in thin client computing and global technology infrastructure.
          </p>
        </div>
      </section>

      {/* Featured Media Section */}
      <section className="featured-media">
        <div className="container">
          <h2 className="section-title">Featured Article</h2>
          <div className="featured-article">
            <div className="featured-image">
              <img src={featuredArticle.image} alt={featuredArticle.title} />
              <div className="category-badge">{featuredArticle.category}</div>
            </div>
            <div className="featured-content">
              <div className="article-meta">
                <span className="author">
                  <User size={16} />
                  {featuredArticle.author}
                </span>
                <span className="date">
                  <Calendar size={16} />
                  {formatDate(featuredArticle.date)}
                </span>
                <span className="read-time">
                  <Clock size={16} />
                  {featuredArticle.readTime}
                </span>
              </div>
              <h3 className="featured-title">{featuredArticle.title}</h3>
              <p className="featured-excerpt">{featuredArticle.excerpt}</p>
              <Link to={`/blog/${featuredArticle.id}`} className="read-more-btn">
                Read Full Article
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="articles-grid">
        <div className="container">
          <h2 className="section-title">Latest Articles</h2>
          <div className="articles-container">
            {articles.map((article) => (
              <article key={article.id} className="article-card">
                <div className="article-image">
                  <img src={article.image} alt={article.title} />
                  <div className="category-badge">{article.category}</div>
                </div>
                <div className="article-content">
                  <div className="article-meta">
                    <span className="author">
                      <User size={14} />
                      {article.author}
                    </span>
                    <span className="date">
                      <Calendar size={14} />
                      {formatDate(article.date)}
                    </span>
                    <span className="read-time">
                      <Clock size={14} />
                      {article.readTime}
                    </span>
                  </div>
                  <h3 className="article-title">{article.title}</h3>
                  <p className="article-excerpt">{article.excerpt}</p>
                  <Link to={`/blog/${article.id}`} className="read-more">
                    Read More
                    <ArrowRight size={14} />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="blog-newsletter">
        <div className="container">
          <div className="newsletter-content">
            <h3>Stay Informed</h3>
            <p>Subscribe to our newsletter for the latest updates on ChipServer innovations and global technology trends.</p>
            <Link to="/NewsletterSignup" className="newsletter-btn">
              Subscribe Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog; 